import TabBar from '../../../../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DialogAddNewDoc } from './components/dialog-add-new-doc';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { SettingsDocsType } from '../../../../../api/types/settings/docs/settings-docs-type';
import dateFormat from '../../../../../utils/date-format';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import './docs.settings.page.css';
import { observer } from 'mobx-react-lite';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { deleteDocTypeOperation } from './operations/delete-doc-type-operation';

const DocsSettingsPage = observer(() => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [editDocType, setEditDocType] = useState<SettingsDocsType | null>(null);
  const [deleteDocTypeId, setDeleteDocTypeId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const dialogHide = () => {
    setShowDialog(false);
  };

  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleEditDocType = (docType: SettingsDocsType) => {
    setEditDocType(docType);
  };

  const handleSaveDocType = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.DOC_TYPE,
      id,
      newName,
      setLoading,
    );
  };

  const handleDeleteDocType = async (docTypeId: number) => {
    await deleteDocTypeOperation(docTypeId, setDeleteDocTypeId);
  };

  return (
    <div>
      <Button
        style={{ height: '30px', marginTop: '16px' }}
        label={'הוספה'}
        onClick={dialogDisplay}
      />
      <div style={{ height: '8px' }} />

      <DataTable
        value={globalSettingsStores.docTypes}
        loading={isLoading}
        rows={10}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="docTypeName"
          header="סוגי מסמכים"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="תאריך יצירה"
          sortable
          body={(rowData: SettingsDocsType) =>
            dateFormat.displayFormatDate(new Date(rowData.createdAt))
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SettingsDocsType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סוג מסמך'}
                onClick={() => handleEditDocType(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סוג מסמך'}
                loading={deleteDocTypeId === data.id}
                disabled={deleteDocTypeId !== null}
                onClick={() => handleDeleteDocType(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת סוג מסמך"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '500px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <DialogAddNewDoc closeDialog={dialogHide} />
      </Dialog>

      <EditTextDialog
        id={editDocType?.id}
        value={editDocType?.docTypeName}
        title="עריכת סוג מסמך"
        label="שם סוג המסמך"
        loading={loading}
        onSave={handleSaveDocType}
        onHide={() => setEditDocType(null)}
      />
    </div>
  );
});

export default DocsSettingsPage;
